import request from '../utils/request'

export function arsVisitLastApi (customerId, visitType) {
  // visitType=(0-门店维护,1-门店拓展,2-reorder
  return request({
    url: `api/visit/lastVisit/${customerId}?visitType=${visitType}`,
    method: 'get'
  })
}

export function arsVisitAddOrUpdateApi (data) {
  return request({
    url: 'api/visit/addOrUpdate',
    method: 'post',
    data
  })
}

export function arsVisitInfoApi (visitId) {
  return request({
    url: `api/visit/info/${visitId}`,
    method: 'get'
  })
}

export function changeListPageApi (data) {
  return request({
    url: 'api/change/listPage',
    method: 'post',
    data
  })
}
